// extracted by mini-css-extract-plugin
module.exports = {"checkboxSquare":"CheckboxSquare_checkboxSquare__odlpJ","checked":"CheckboxSquare_checked__2meiT"};